export default __webpack_public_path__ + "static/media/fakurian-design-light.87aa40db.png";